import React from 'react';
import { Box, Button, CardFooter } from '@saviynt/design-system';

import { useInvertedLocalize } from '../../../../utils/localization';
import invertedMessages from '../messages';

import './RoleCardFooterCompact.css';

interface RoleCardFooterCompactProps {
  onViewDetails: () => void;
}

/**
 * RoleCardFooterCompact component displaying confidence pill and view details button
 * for the compact card variant
 *
 * @param props - The component props
 * @returns JSX element containing the compact footer display
 */
function RoleCardFooterCompact({ onViewDetails }: RoleCardFooterCompactProps) {
  const l = useInvertedLocalize(invertedMessages);

  return (
    <>
      {/* separator */}
      <hr className='Roles-RoleCardFooterCompact-separator' />

      <CardFooter className='Roles-RoleCardFooterCompact'>
        <Box className='Roles-RoleCardFooterCompact-actions'>
          <Button
            kind='outlined'
            size='small'
            onClick={onViewDetails}
            className='Roles-RoleCardFooterCompact-viewButton'>
            {l('View Details')}
          </Button>
        </Box>
      </CardFooter>
    </>
  );
}

export default RoleCardFooterCompact;
